export default __webpack_public_path__ + "static/media/IMG_1424.53343fdc.jpg";